import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";
import { useTranslation } from "react-i18next";

function Name({ setDocumentName }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.name}>
      <p className={styles.title}>{t("documentCreation.name.title")}</p>
      <input
        className={styles.input}
        placeholder={t("documentCreation.name.placeholder")}
        onChange={(e) => {
          setDocumentName(e.target.value);
        }}
        autoFocus
      />
    </div>
  );
}

export { Name };
